/** Тип данных для хранения серверов в config.json */
export interface ConfigServer {
    name: string;
    documentPostfixTitle: string;
    url: string;
    default?: boolean; // default is optional
}

/** Данные о заказчике в config.json */
export interface ConfigCustomer {
    name: string;
}

/** JSON объект из файла config.json */
export interface ConfigObject {
    customer: ConfigCustomer;
    servers: ConfigServer[];
}

/** Загружает config.json */
export const configFileLoad = async (): Promise<ConfigObject> => {
    try {
        const response = await fetch(`${import.meta.env.BASE_URL}config.json`);
        if (!response.ok) {
            throw new Error("Ошибка при загрузке файла конфигурации. Файл не найден.");
        }

        const config = await response.json();

        return config;
    } catch (err) {
        console.error(err);
        throw new Error("Ошибка при чтении конфигурационного файла.");
    }
};
